/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps*/
/* eslint-disable array-callback-return*/
import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate, useParams } from "react-router-dom";
import Page from "../../Components/Page/Page";
import { useTranslate } from "../../Translate";
import { NumericInput, ErrorPage, handleLogError,openNotificationWithIcon } from "../../Helpers/Helpers";
import { Button, message, Steps, Select, Form, Modal, Divider } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { AccountsService } from "../../Service/AccountsService";
import { UsersService } from "../../Service/UsersService";
import { CreditsService } from "../../Service/CreditsService";
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xl: {
      span: 8,
    },

    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xl: {
      span: 8,
    },
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 2,
      offset: 2,
    },
    sm: {
      span: 10,
      offset: 10,
    },
  },
};

const Move = (props) => {
  const { type } = props;
  const i18n = useTranslate();
  const { t } = i18n;
  const { keycloak } = useKeycloak();
  const { path } = useParams();
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const types = path.substring(0, 1);
  const id = path.substring(1);

  const handleFinish = (data) => {
    Move(data);
  };

  const Move = async (data) => {
    setLoading(true);
    try {
      const response = await CreditsService.move(
        keycloak.token,
        data,
        type
      );
      ErrorPage(response, navigate);
      console.log(response);
      if (response.status == 200) {
        openNotificationWithIcon('success', "Success", "Credito trasferito con successo!");
        type ==='admin' ? navigate("/admin/credits") : navigate("/credits");
      }  else {
        openNotificationWithIcon('error', "Error", "Errore nel trasferimento del credito.\r\n"+response.data.message);
      }
    } catch (error) {
      handleLogError(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      /*carico la lookup degli accounts*/
      const lk_accounts = [];
      //const response_accounts = await AccountsService.getLookup();
      const response_accounts = await UsersService.accountsByUserId(keycloak.token,type);
      response_accounts.data.map((account) => {
        lk_accounts.push(
          <Option value={account.id} key={account.id}>
            {account.companyname.trim()}
          </Option>
        );
        return true;
      });
      setGroups(lk_accounts);
      ErrorPage(response_accounts, navigate);
      form.setFieldsValue({
        sourceGroup: parseInt(id),
      });
    } catch (error) {
      handleLogError(error);
    }
    setLoading(false);
  };

  const handleBack = () => {
    navigate("/admin/credits");
  };
  return (
    <Page loading={loading} inner>
      <Divider
        orientation="left"
        orientationMargin="0"
        style={{ color: "#e61e1e" }}
      >
        {t("movecredits")}
      </Divider>
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="form-move"
        onFinish={handleFinish}
        scrollToFirstError
      >
        <Form.Item label={t("sourceGroup")} name="sourceGroup">
          <Select
            style={{ width: "100%" }}
            optionFilterProp="children"
            disabled={true}
            filterOption={(input, option) => option.children.includes(input)}
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {groups}
          </Select>
        </Form.Item>
        <Form.Item label={t("destinationGroup")} name="destinationGroup"  rules={[
            {
              required: true,
              message: t("ckDestinationGroup"),
            },
          ]}>
          <Select
            style={{ width: "100%" }}
            optionFilterProp="children"
            filterOption={(input, option) => option.children.includes(input)}
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {groups}
          </Select>
        </Form.Item>
        <Form.Item
          label={t("transactionAmount")}
          name="transactionAmount"
          rules={[
            {
              required: true,
              message: t("ckTransactionAmount"),
            },
          ]}
        >
          <NumericInput />
        </Form.Item>

        <Form.Item
          label={t("causal")}
          name="causale"
          rules={[
            {
              required: true,
              message: t("ckCausal"),
            },
          ]}
        >
          <TextArea></TextArea>
        </Form.Item>
        <Form.Item></Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            {t("save")}
          </Button>
          <Button
            style={{
              margin: "0 8px",
            }}
            onClick={handleBack}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </Page>
  );
};

export default Move;
